<script>
import Vue from "vue";

export default Vue.extend({
  name: "InvitationHeader",
  props: {
    invitation: {
      type: Object,
      required: true,
    },
  },
});
</script>

<template>
  <h2 class="text-center">
    <span v-if="invitation.inviterName" class="h4 text-locomotion">
      {{ invitation.inviterName }}
    </span>
    <span v-else class="h4 text-muted">
      {{ $t("components.invitation.invitation_header.anonymous") }}
    </span>
    <span class="h4 text-muted"> {{ $t("components.invitation.invitation_header.invite") }} </span
    ><br />
    {{
      invitation.communityName
        ? $t("components.invitation.invitation_header.community", {
            name: invitation.communityName,
          })
        : $t("components.invitation.invitation_header.default")
    }}
  </h2>
</template>

<style scoped lang="scss"></style>
